import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { KIDDEE_FAQ } from "@/config/kiddee";
import { KIDDEE_PAGE } from "@/constants/testIds";

const useFaqJsonLd = () => {
  useEffect(() => {
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: KIDDEE_FAQ.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
    });
    document.head.appendChild(el);
    return () => el.remove();
  }, []);
};

export const KiddeeFaq = () => {
  useFaqJsonLd();
  return (
    <section data-testid={KIDDEE_PAGE.faq} className="max-w-3xl mx-auto px-4 sm:px-6 py-16 sm:py-20">
      <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#4E7B68]">Questions</p>
      <h2 className="font-heading mt-3 text-2xl sm:text-3xl font-extrabold tracking-tight">Good to know before you buy</h2>
      <Accordion type="single" collapsible className="mt-6">
        {KIDDEE_FAQ.map((f, i) => (
          <AccordionItem key={f.q} value={`q${i}`} className="border-[#E7E0D3]">
            <AccordionTrigger data-testid={KIDDEE_PAGE.faqItem(i)} className="text-left font-heading font-bold text-base min-h-[44px]">{f.q}</AccordionTrigger>
            <AccordionContent className="text-stone-600 leading-relaxed text-sm sm:text-base">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
      <p className="mt-6 text-sm text-stone-600">More details on our <Link to="/policies" data-testid={KIDDEE_PAGE.policiesLink} className="underline text-[#E06D44]">shipping, returns & contact</Link> page.</p>
    </section>
  );
};
